msgid ""
msgstr ""
"POT-Creation-Date: 2026-09-11 17:28+0800\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: zh-CN\n"
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Plural-Forms: \n"

#: src/components/SessionDirectory.tsx
msgid " (conversation default)"
msgstr "（对话默认）"

#: src/components/SessionDirectory.tsx
msgid " (current)"
msgstr "（当前）"

#: src/components/UserPanel.tsx
msgid "+ create agent"
msgstr "+ 创建 Agent"

#: src/components/NormalizedConversation.tsx
msgid "A message could not be sent."
msgstr "有一条消息发送失败。"

#: src/i18n/errorMessages.ts
msgid "A Zone with this name already exists."
msgstr "已存在同名分区。"

#: src/components/UserPanel.tsx
msgid "Account"
msgstr "账号"

#: src/components/UserPresenceDot.tsx
msgid "Active just now"
msgstr "刚刚活跃"

#: src/components/NormalizedConversation.tsx
#: src/components/UserPanel.tsx
msgid "Agent"
msgstr "Agent"

#: src/i18n/errorMessages.ts
msgid "Agents cannot mention everyone."
msgstr "Agent 不能提及所有人。"

#: src/components/UserName.tsx
msgid "APP"
msgstr "应用"

#: src/components/common/PageHeader.tsx
msgid "Back"
msgstr "返回"

#: src/i18n/documentTitle.ts
msgid "Borgee Admin"
msgstr "Borgee 管理后台"

#: src/stores/useServerStore.ts
msgid "Browser storage could not be cleared; reload may retry Project recovery."
msgstr "无法清除浏览器存储，重新加载可能会再次尝试恢复项目。"

#: src/stores/useServerStore.ts
msgid "Browser storage could not be cleared; reload may retry recovery."
msgstr "无法清除浏览器存储，重新加载可能会再次尝试恢复。"

#: src/stores/useServerStore.ts
msgid "Browser storage could not be cleared; reload may retry this request."
msgstr "无法清除浏览器存储，重新加载可能会重试此请求。"

#: src/components/ClearConfirmModal.tsx
#: src/components/ConfirmDeleteModal.tsx
msgid "Cancel"
msgstr "取消"

#: src/hooks/useWebSocket.ts
msgid "Channel #{name} was deleted."
msgstr "频道 #{name} 已被删除。"

#: src/i18n/errorMessages.ts
msgid "Check the Zone details and try again."
msgstr "请检查分区信息后重试。"

#: src/i18n/errorMessages.ts
msgid "Choose a valid location for this conversation."
msgstr "请为此会话选择有效的位置。"

#: src/i18n/errorMessages.ts
msgid "Choose a valid notification preference."
msgstr "请选择有效的通知偏好。"

#: src/components/ClearConfirmModal.tsx
msgid "Clear"
msgstr "清除"

#: src/components/ClearConfirmModal.tsx
msgid "Clear local chat history? This only clears the local display and does not affect server data."
msgstr "确定清除本地聊天记录？此操作仅清除本地显示，不影响服务端数据。"

#: src/components/common/PageHeader.tsx
msgid "Close"
msgstr "关闭"

#: src/components/ShellLayout.tsx
msgid "Collapse sidebar"
msgstr "收起侧栏"

#: src/components/ConnectionStatus.tsx
msgid "Connecting…"
msgstr "连接中…"

#: src/components/ConnectionStatus.tsx
msgid "Connection lost. Reconnecting…"
msgstr "连接断开，正在重连…"

#: src/components/NormalizedSessionComposer.tsx
msgid "Conversation unavailable. Your draft is preserved."
msgstr "当前对话不可用。草稿已保留。"

#: src/components/NormalizedConversation.tsx
msgid "Conversation view"
msgstr "会话视图"

#: src/stores/useServerStore.ts
msgid "Could not create the Project."
msgstr "无法创建项目。"

#: src/App.tsx
msgid "Could not load this Project."
msgstr "无法加载此项目。"

#: src/hooks/useRemoteNodes.ts
msgid "Could not load your computers."
msgstr "无法加载你的电脑。"

#: src/stores/useServerStore.ts
msgid "Could not refresh Project membership."
msgstr "无法刷新项目成员关系。"

#: src/stores/useServerStore.ts
msgid "Could not save Project creation recovery. Check browser storage and try again."
msgstr "无法保存项目创建恢复信息，请检查浏览器存储后重试。"

#: src/hooks/useUserLayout.ts
msgid "Could not save sidebar order. Please try again."
msgstr "侧栏顺序保存失败, 请重试"

#: src/components/UserPanel.tsx
msgid "Could not sign out. Try again."
msgstr "无法退出登录，请重试。"

#: src/lib/visibility.ts
msgid "Creator only"
msgstr "仅创建者"

#: src/components/PersonalSettingsModal.tsx
msgid "Dark Mode"
msgstr "深色模式"

#: src/components/ConfirmDeleteModal.tsx
msgid "Delete"
msgstr "删除"

#: src/components/ConfirmDeleteModal.tsx
msgid "Delete <0>#{channelName}</0>? This cannot be undone."
msgstr "确定删除 <0>#{channelName}</0>？此操作不可恢复。"

#: src/components/ConfirmDeleteModal.tsx
msgid "Delete channel"
msgstr "删除频道"

#: src/components/ConfirmDeleteModal.tsx
msgid "Deleting…"
msgstr "删除中..."

#: src/components/ConnectionStatus.tsx
msgid "Disconnected"
msgstr "连接已断开"

#: src/App.tsx
msgid "Dismiss"
msgstr "关闭"

#: src/lib/notificationPermissionLabels.ts
msgid "Enable notifications"
msgstr "开启通知"

#: src/i18n/errorMessages.ts
msgid "Enter a Guild name."
msgstr "请输入 Guild 名称。"

#: src/lib/use_failure_repair.ts
msgid "Enter a new API key"
msgstr "请输入新的 API 密钥"

#: src/i18n/errorMessages.ts
msgid "Enter a search query."
msgstr "请输入搜索内容。"

#: src/i18n/errorMessages.ts
msgid "Everyone was mentioned recently. Please try again later."
msgstr "最近已提及所有人，请稍后重试。"

#: src/components/ShellLayout.tsx
msgid "Expand sidebar"
msgstr "展开侧栏"

#: src/components/SessionDirectory.tsx
msgid "Filter"
msgstr "筛选"

#: src/components/SessionDirectory.tsx
msgid "Filter loaded sessions"
msgstr "筛选已加载的会话"

#: src/components/LanguageSelect.tsx
msgid "Follow system"
msgstr "跟随系统"

#: src/components/PersonalSettingsModal.tsx
msgid "General"
msgstr "常规"

#: src/components/UserPanel.tsx
msgid "Human"
msgstr "用户"

#: src/lib/notificationPermissionLabels.ts
msgid "Install the Borgee desktop app"
msgstr "安装 Borgee 桌面应用"

#: src/components/LanguageSelect.tsx
msgid "Language"
msgstr "语言"

#: src/components/UserPresenceDot.tsx
msgid "Last active {lastSeen}"
msgstr "最近活跃于{lastSeen}"

#: src/components/PersonalSettingsModal.tsx
msgid "Light Mode"
msgstr "浅色模式"

#: src/App.tsx
msgid "Loading Agent…"
msgstr "正在加载 Agent…"

#: src/App.tsx
msgid "Loading Project..."
msgstr "正在加载项目…"

#: src/components/SessionDirectory.tsx
msgid "Loading sessions…"
msgstr "正在加载会话…"

#: src/App.tsx
msgid "Loading..."
msgstr "正在加载..."

#: src/App.tsx
msgid "Loading…"
msgstr "正在加载…"

#: src/components/UserPanel.tsx
msgid "Logout"
msgstr "退出登录"

#: src/lib/visibility.ts
msgid "Members only"
msgstr "成员可见"

#: src/lib/capability-bundles.ts
msgid "Mention capabilities"
msgstr "提及能力"

#: src/i18n/errorMessages.ts
msgid "Mention recipients must be selected through the message editor."
msgstr "必须通过消息编辑器选择提及对象。"

#: src/components/NormalizedConversation.tsx
msgid "Messages"
msgstr "消息"

#: src/components/ShellLayout.tsx
msgid "Navigation"
msgstr "导航"

#: src/components/NormalizedSessionComposer.tsx
msgid "No active turn was stopped. The turn may have already finished."
msgstr "未停止任何进行中的轮次。该轮次可能已经结束。"

#: src/components/SessionDirectory.tsx
msgid "No registered sessions. Send a message to start a session."
msgstr "暂无已登记会话。发送消息以开始会话。"

#: src/components/SessionDirectory.tsx
msgid "No sessions match this filter."
msgstr "没有匹配的会话。"

#: src/lib/notificationPermissionLabels.ts
msgid "Notifications enabled"
msgstr "已开启通知"

#: src/lib/notificationPermissionLabels.ts
msgid "Notifications were blocked. Enable them in your browser settings."
msgstr "通知已被浏览器拒绝，请到浏览器设置开启。"

#: src/components/UserPresenceDot.tsx
msgid "Offline"
msgstr "离线"

#: src/lib/syncState.ts
msgid "Offline mode"
msgstr "离线模式"

#: src/components/UserPresenceDot.tsx
msgid "Online"
msgstr "在线"

#: src/components/SessionDirectory.tsx
msgid "Only part of the session list is available."
msgstr "当前仅显示部分会话。"

#: src/i18n/errorMessages.ts
msgid "Only the sender can edit this message."
msgstr "只有发送者可以编辑此消息。"

#: src/components/NormalizedConversation.tsx
msgid "Open Messages to retry"
msgstr "打开消息视图重试"

#: src/lib/router.tsx
msgid "Open overview"
msgstr "打开概览"

#: src/components/SessionDirectory.tsx
msgid "Opened sessions"
msgstr "已打开的会话"

#: src/lib/use_failure_repair.ts
msgid "Opening logs…"
msgstr "正在打开日志…"

#: src/lib/router.tsx
msgid "Page not found"
msgstr "找不到页面"

#: src/i18n/errorMessages.ts
msgid "Please try again."
msgstr "请重试。"

#: src/App.tsx
msgid "Preparing your workspace. Refresh shortly…"
msgstr "正在准备你的工作区, 稍候刷新…"

#: src/components/UserPanel.tsx
msgid "Profile and settings"
msgstr "资料与设置"

#: src/App.tsx
msgid "Project not found"
msgstr "找不到项目"

#: src/lib/capability-bundles.ts
msgid "Reading capabilities"
msgstr "阅读能力"

#: src/lib/use_failure_repair.ts
msgid "Reconnecting…"
msgstr "正在重连…"

#: src/components/SessionDirectory.tsx
msgid "Refresh sessions"
msgstr "刷新会话"

#: src/components/ShellLayout.tsx
msgid "Resize thread"
msgstr "调整话题面板宽度"

#: src/App.tsx
msgid "Retry"
msgstr "重试"

#: src/components/NormalizedConversation.tsx
#: src/components/SessionDirectory.tsx
msgid "Retry sessions"
msgstr "重新加载会话"

#: src/App.tsx
msgid "Select a computer from the sidebar"
msgstr "从侧栏选择一台计算机"

#: src/App.tsx
msgid "Select a conversation to start messaging"
msgstr "选择一个会话以开始发送消息"

#: src/components/SessionDirectory.tsx
msgid "Select a session"
msgstr "选择会话"

#: src/components/NormalizedConversation.tsx
msgid "Select a session to continue."
msgstr "请选择一个会话以继续。"

#: src/App.tsx
msgid "Select an agent from the sidebar"
msgstr "从侧栏选择一个 Agent"

#: src/components/SessionDirectory.tsx
msgid "Selected session"
msgstr "所选会话"

#: src/components/NormalizedSessionComposer.tsx
msgid "Send a message to this conversation"
msgstr "向此对话发送消息"

#: src/components/NormalizedConversation.tsx
msgid "Send or remove attached images in Messages before switching to Session."
msgstr "请先在消息视图中发送或移除附加图片，再切换到会话。"

#. placeholder {0}: agentName ?? t`this agent`
#: src/components/NormalizedConversation.tsx
msgid "Send your first message to {0} below. Session activity and any available controls will appear after the agent starts the session. Your conversation messages remain visible while it starts."
msgstr "在下方向 {0} 发送第一条消息。智能体启动会话后，将显示会话活动和可用的控制项。启动期间，你的对话消息仍会保持可见。"

#: src/components/NormalizedSessionComposer.tsx
msgid "Sending a new message to this session is not available here."
msgstr "此处暂不支持向该会话发送新消息。"

#: src/components/NormalizedConversation.tsx
msgid "Sending message…"
msgstr "发送消息中…"

#: src/components/NormalizedConversation.tsx
#: src/components/SessionDirectory.tsx
msgid "Session"
msgstr "会话"

#: src/components/NormalizedSessionComposer.tsx
msgid "Session controls are unavailable. Your draft is preserved."
msgstr "会话控制暂不可用，草稿已保留。"

#: src/components/SessionDirectory.tsx
msgid "Session ID"
msgstr "会话 ID"

#: src/components/NormalizedConversation.tsx
msgid "Session not started"
msgstr "会话尚未开始"

#: src/components/NormalizedConversation.tsx
msgid "Session setup"
msgstr "会话设置"

#: src/components/SessionDirectory.tsx
msgid "Sessions could not be loaded."
msgstr "无法加载会话。"

#: src/components/SessionDirectory.tsx
msgid "Sessions in this direct message"
msgstr "当前私聊中的会话"

#: src/components/PersonalSettingsModal.tsx
#: src/components/UserPanel.tsx
msgid "Settings"
msgstr "设置"

#: src/lib/syncState.ts
msgid "Synced"
msgstr "已同步"

#: src/lib/syncState.ts
msgid "Syncing…"
msgstr "同步中…"

#: src/components/NormalizedSessionComposer.tsx
msgid "The agent rejected this control. Your draft is preserved."
msgstr "智能体拒绝了此操作，草稿已保留。"

#: src/hooks/useWebSocket.ts
msgid "The channel was deleted."
msgstr "频道已被删除"

#: src/components/NormalizedSessionComposer.tsx
msgid "The control result is unconfirmed. Check the session state before trying again. Your draft is preserved."
msgstr "操作结果尚未确认，请检查会话状态后再重试。草稿已保留。"

#: src/i18n/errorMessages.ts
msgid "The conversation location changed. Refresh and try again."
msgstr "会话位置已更改，请刷新后重试。"

#: src/i18n/errorMessages.ts
msgid "The Guild icon is too long."
msgstr "Guild 图标过长。"

#: src/components/NormalizedSessionComposer.tsx
msgid "The native turn has already finished. Your draft is preserved."
msgstr "原生轮次已结束，草稿已保留。"

#: src/i18n/errorMessages.ts
msgid "The operation failed (error code: {code})."
msgstr "操作失败（错误代码：{code}）。"

#: src/App.tsx
msgid "The Project was created, but its data could not be loaded. Reload to retry."
msgstr "项目已创建，但无法加载其数据。请重新加载以重试。"

#: src/stores/useServerStore.ts
msgid "The Project was created, but recovery could not be completed. Retry to load the Project."
msgstr "项目已创建，但未能完成恢复。请重试加载项目。"

#: src/i18n/errorMessages.ts
msgid "The requested item is no longer available."
msgstr "请求的项目已不可用。"

#: src/i18n/errorMessages.ts
msgid "The search query is too long."
msgstr "搜索内容过长。"

#: src/i18n/errorMessages.ts
msgid "The search query is too short."
msgstr "搜索内容过短。"

#: src/components/PersonalSettingsModal.tsx
msgid "Theme"
msgstr "主题"

#: src/i18n/errorMessages.ts
msgid "This action can only edit messages in direct conversations."
msgstr "此操作只能编辑私信中的消息。"

#: src/components/NormalizedConversation.tsx
msgid "this agent"
msgstr "此智能体"

#: src/i18n/errorMessages.ts
msgid "This channel is read-only. Only its creator can send messages."
msgstr "只读频道，仅创建者可发言。"

#: src/i18n/errorMessages.ts
msgid "This conversation field cannot be changed."
msgstr "无法修改此会话字段。"

#: src/i18n/errorMessages.ts
msgid "This notification subscription belongs to another account."
msgstr "此通知订阅属于另一个账号。"

#: src/i18n/errorMessages.ts
msgid "This notification subscription is invalid. Enable notifications again."
msgstr "此通知订阅无效，请重新开启通知。"

#: src/i18n/errorMessages.ts
msgid "This request was already used with different details. Try again."
msgstr "此请求已用于其他内容，请重试。"

#: src/components/NormalizedSessionComposer.tsx
msgid "This session does not support that control."
msgstr "此会话不支持该操作。"

#: src/components/NormalizedConversation.tsx
msgid "This session is unavailable. Your selection is preserved."
msgstr "此会话暂不可用。已保留你的选择。"

#: src/i18n/errorMessages.ts
msgid "This Zone is not empty. Archived channels also prevent deletion."
msgstr "此分区非空，已归档频道也会阻止删除。"

#: src/i18n/errorMessages.ts
msgid "This Zone no longer exists."
msgstr "此分区已不存在。"

#: src/i18n/errorMessages.ts
msgid "Too many requests. Please try again later."
msgstr "请求过于频繁，请稍后重试。"

#: src/lib/visibility.ts
msgid "Visible to the organization"
msgstr "组织内可见"

#: src/components/NormalizedSessionComposer.tsx
msgid "Wait until the agent is idle before changing this session."
msgstr "请等待智能体空闲后再修改会话。"

#: src/components/UserPanel.tsx
msgid "with <0>{agentCount}</0> {agentCount, plural, one {agent} other {agents}}"
msgstr "拥有 <0>{agentCount}</0> {agentCount, plural, one {个 Agent} other {个 Agent}}"

#: src/lib/capability-bundles.ts
msgid "Workspace capabilities"
msgstr "工作能力"

#: src/i18n/errorMessages.ts
msgid "You are not a member of this conversation."
msgstr "你不是此会话的成员。"

#: src/i18n/errorMessages.ts
msgid "You do not have permission to perform this action."
msgstr "你没有权限执行此操作。"

#: src/hooks/useUnsavedChangesGuard.ts
msgid "You have unsaved changes:\n"
"{changes}\n"
"\n"
"Leave this page?"
msgstr "你有未保存的更改：\n"
"{changes}\n"
"\n"
"确认离开此页面吗？"

#: src/hooks/useUnsavedChangesGuard.ts
msgid "You have unsaved changes. Leave this page?"
msgstr "有未保存的改动, 确认离开当前页面吗?"

#: src/stores/useServerStore.ts
msgid "You no longer have access to the created Project."
msgstr "你已无权访问所创建的项目。"

#: src/components/UserPanel.tsx
msgid "your agents"
msgstr "你的 Agent"

#: src/components/LanguageSelect.tsx
msgid "Your language choice could not be saved in this browser. It will apply until this page is closed."
msgstr "无法在此浏览器保存语言偏好，本次选择将在关闭页面前生效。"

#: src/i18n/errorMessages.ts
msgid "Your session ended. Sign in again."
msgstr "会话已结束，请重新登录。"
